import { useAuthContext, usePermissions } from '/src/hooks';

import { UpsellWall } from '/src/components/UpsellWall';
import { FEATURES } from '/src/features/_global/constants';

import FeaturedImagePNG from '@crazyegginc/hatch/dist/images/illustration-upsell-ctas.png';
import FeaturedImageWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-ctas.webp';
import LeftPeoplePhotoPNG from '@crazyegginc/hatch/dist/images/people-emily-g.png';
import RightLogoWebP from '@crazyegginc/hatch/dist/images/logo-scrt-society.webp';
import RightLogoPNG from '@crazyegginc/hatch/dist/images/logo-scrt-society.png';
import { ReactComponent as G2LogoIcon } from '@crazyegginc/hatch/dist/images/logo-g2.svg';

const TEXT_LIST = [
  {
    text: 'Stop cart abandonment in its tracks with special offers',
  },
  {
    text: 'Grow your email & SMS list — every contact is a potential sale',
  },
  {
    text: 'Get the word out on special offers, events, and product launches',
  },
];

const TextContent = ({ canManageBilling, ownerEmail, isStripeUser }) => {
  return (
    <>
      <UpsellWall.Title
        titleText={
          canManageBilling
            ? "Don't let leads, subscribers, and buyers slip away"
            : 'Request an upgrade to the Starter plan'
        }
        subtitleText={
          !canManageBilling
            ? 'Increase engagement with CTAs to highlight promotions, direct traffic to key pages, or grow your mailing list.'
            : null
        }
      />
      {canManageBilling ? (
        <UpsellWall.List list={TEXT_LIST} />
      ) : (
        <>
          <p className="mb-6 text-black-pearl-500 text-sm">
            Contact your Account Admin at <strong>{ownerEmail}</strong> to upgrade and start building CTAs.
          </p>
        </>
      )}
      <UpsellWall.CTA
        metricType="ctas_upsell_paywall"
        canManageBilling={canManageBilling}
        ownerEmail={ownerEmail}
        isStripeUser={isStripeUser}
      />
    </>
  );
};

const LeftContent = () => {
  return (
    <>
      <UpsellWall.TestimonialText textClassNames="mb-10">
        Super easy to integrate, and has some additional cool features outside of heatmaps like A/B testing, surveys,
        and CTAs. Can also take recordings of actual user experiences on the site, which is very helpful for identifying
        errors.
      </UpsellWall.TestimonialText>
      <UpsellWall.TestimonialPerson
        name="Emily G., Validated G2 Reviewer"
        title="Director of Media & Analytics, Mid-Market (51-1,000 employees)"
        imagePNG={LeftPeoplePhotoPNG}
        imageWidth="40"
        imageHeight="40"
        logoSVG={G2LogoIcon}
        logoWidth="40"
        logoHeight="40"
        logoAlt="g2"
      />
    </>
  );
};

const RightContent = () => {
  return (
    <>
      <UpsellWall.TestimonialText textClassNames="mb-10">
        Crazy Egg has become my favorite Shopify app. As a shop owner, I&apos;m inundated with ideas, data, and
        opportunities to improve the customer experience and drive up my conversion rates&hellip; ultimately, saves me
        time by getting me to the best and biggest opportunities in minutes. It&apos;s not only my favorite app, I
        can&apos;t live without it.
      </UpsellWall.TestimonialText>
      <UpsellWall.TestimonialPerson
        name="scrt society "
        title="Shopify Store Owner"
        logoWebP={RightLogoWebP}
        logoPNG={RightLogoPNG}
        logoHeight="40"
        logoWidth="40"
        logoAlt="scrt society"
      />
    </>
  );
};

export function CTAsUpsellPaywall() {
  const { currentAccount } = useAuthContext();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <UpsellWall>
      <UpsellWall.TopPanel
        textContent={
          <TextContent
            canManageBilling={canManageBilling}
            ownerEmail={currentAccount.ownerEmail}
            isStripeUser={isStripeUser}
          />
        }
        imagePNG={FeaturedImagePNG}
        imageWebP={FeaturedImageWebP}
        imageWidth="522"
        imageHeight="256"
        imageAlt="ctas feature"
      />
      <UpsellWall.BottomPanel isSeparate={true} leftContent={<LeftContent />} rightContent={<RightContent />} />
    </UpsellWall>
  );
}
